import { createFileRoute, redirect } from "@tanstack/react-router";

/** Packs moved into the client's billing tab; old links and bookmarks land there. */
export const Route = createFileRoute("/(private)/trainees/$clientId/packs")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/trainees/$clientId/billing", params, replace: true });
  },
});
